<template>
  <div class="homepage">
    <!-- 首页banner -->
    <div class="home-banner">
      <!-- 背景图片 -->
      <div class="banner-image">
        <el-image
          class="image"
          :src="bannerImage.cases"
          :alt="bannerImage.title"
          fit="contain"
        >
        </el-image>
      </div>
      
      <!-- 固定文字内容 -->
      <div class="fixed-content">
        <div class="carousel">
          <div class="title">
            <div class="title-line">高客单领域智能营销系统</div>
          </div>
          <div class="text">不止赋能营销，更赋能数字管理</div>
          <div class="tags">
            <div class="tag-item">
              <img :src="require('@/assets/img/banner产品icon/小程序.png')" alt="小程序" class="tag-icon" />
              <span>小程序</span>
            </div>
            <div class="tag-item">
              <img :src="require('@/assets/img/banner产品icon/销冠crm.png')" alt="销冠CRM" class="tag-icon" />
              <span>销冠CRM</span>
            </div>
            <div class="tag-item">
              <img :src="require('@/assets/img/banner产品icon/营销云.png')" alt="营销云" class="tag-icon" />
              <span>营销云</span>
            </div>
          </div>
          <div class="first-word-big-button" @click="goReservation(0)">预约体验</div>
        </div>
      </div>
    </div>
    
    <!-- 移动端版本 -->
    <div class="home-banner-mobile">
      <!-- 背景图片 -->
      <div class="banner-image">
        <el-image
          class="image"
          :src="bannerImage.minCases"
          :alt="bannerImage.title"
          fit="cover"
        ></el-image>
      </div>
      
      <!-- 固定文字内容 -->
      <div class="fixed-content-mobile">
        <div class="carousel">
          <div class="title">
            <div class="title-line">高客单领域智能营销系统</div>
          </div>
          <div class="text">不止赋能营销，更赋能数字管理</div>
          <div class="tags">
            <div class="tag-item">
              <img :src="require('@/assets/img/banner产品icon/小程序.png')" alt="小程序" class="tag-icon" />
              <span>小程序</span>
            </div>
            <div class="tag-item">
              <img :src="require('@/assets/img/banner产品icon/销冠crm.png')" alt="销冠CRM" class="tag-icon" />
              <span>销冠CRM</span>
            </div>
            <div class="tag-item">
              <img :src="require('@/assets/img/banner产品icon/营销云.png')" alt="营销云" class="tag-icon" />
              <span>营销云</span>
            </div>
          </div>
          <div class="first-word-big-button" @click="goReservation(0)">预约体验</div>
        </div>
      </div>
    </div>

    <!-- Logo墙 -->
    <div class="logo-wall">
      <div class="logo-wall-container">
        <!-- 头部客户认可：滚动展示 -->
        <div class="logo-scroll-wrapper">
          <div class="logo-scroll-content" :class="{ paused: isPaused }" @mouseenter="pauseAnimation" @mouseleave="resumeAnimation">
            <!-- 第一组logo -->
            <div class="logo-group">
              <div class="logo-item" v-for="logo in logoList" :key="logo.name">
                <img :src="logo.src" :alt="logo.name" />
              </div>
            </div>
            <!-- 第二组logo（用于无缝滚动） -->
            <div class="logo-group">
              <div class="logo-item" v-for="logo in logoList" :key="logo.name + '_copy'">
                <img :src="logo.src" :alt="logo.name" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 全链路数字营销服务平台板块 -->
    <div class="marketing-platform-section">
      <!-- 背景覆盖层 -->
      <div class="platform-bg-overlay"></div>
      
      <!-- 背景装饰元素 -->
      <div class="platform-bg-decoration platform-bg-left"></div>
      <div class="platform-bg-decoration platform-bg-right"></div>
      <div class="platform-bg-decoration platform-bg-bottom"></div>
      
      <div class="platform-container">
        <div class="platform-header">
          <h2 class="platform-title">直面高客单价营销痛点，构建全链路智能营销体系</h2>
          <p class="platform-subtitle">从全渠道精准获客，到线上线下协同运营转化，依托全链路数字智能营销平台，打造以客户为中心的数字化运营闭环，破解高客单价业务增长难题</p>
        </div>
        <div class="platform-content">
          <div class="platform-image">
            <el-image
              :src="require('@/assets/img/活数据.png')"
              alt="全链路数字营销服务平台"
              :preview-src-list="[require('@/assets/img/活数据.png')]"
              fit="contain"
            >
            </el-image>
          </div>
        </div>
      </div>
    </div>

    <!-- 产品矩阵板块 -->
    <div class="product-matrix-section">
      <div class="product-matrix-container">
        <div class="product-matrix-header">
          <h2 class="product-matrix-title">深度融合 B2b2c 场景，打造更符合国情的数字营销工具</h2>
          <p class="product-matrix-subtitle">从集团到单店，从大客户到中小客户，都可以用简单的产品架构，支撑复杂的业务场景</p>
        </div>
        
        <div class="product-matrix-content">
          <!-- 小程序产品卡片 -->
          <div class="product-card">
            <div class="product-header">
              <div class="product-title-wrapper">
                <img :src="require('@/assets/img/banner产品icon/小程序.png')" alt="小程序" class="product-icon" />
                <h3 class="product-title">小程序</h3>
              </div>
              <p class="product-desc">客户运营</p>
            </div>
            <div class="product-features">
              <div class="feature-grid">
                <div class="feature-item" v-for="(feature, index) in miniProgramFeatures" :key="index">
                  <div class="feature-icon">
                    <img :src="feature.icon" :alt="feature.title" />
                  </div>
                  <div class="feature-content">
                    <h4 class="feature-title">{{ feature.title }}</h4>
                    <p class="feature-desc">{{ feature.desc }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-footer">
              <button class="learn-more-btn" @click="learnMore('miniprogram')">
                了解更多 >
              </button>
            </div>
          </div>

          <!-- 销冠CRM产品卡片 -->
          <div class="product-card">
            <div class="product-header">
              <div class="product-title-wrapper">
                <img :src="require('@/assets/img/banner产品icon/销冠crm.png')" alt="销冠CRM" class="product-icon" />
                <h3 class="product-title">
                  销冠CRM
                  <span class="app-badge">APP</span>
                </h3>
              </div>
              <p class="product-desc">销售赋能</p>
            </div>
            <div class="product-features">
              <div class="feature-grid">
                <div class="feature-item" v-for="(feature, index) in crmFeatures" :key="index">
                  <div class="feature-icon">
                    <img :src="feature.icon" :alt="feature.title" />
                  </div>
                  <div class="feature-content">
                    <h4 class="feature-title">{{ feature.title }}</h4>
                    <p class="feature-desc">{{ feature.desc }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-footer">
              <button class="learn-more-btn" @click="learnMore('crm')">
                了解更多 >
              </button>
            </div>
          </div>

          <!-- 营销云产品卡片 -->
          <div class="product-card">
            <div class="product-header">
              <div class="product-title-wrapper">
                <img :src="require('@/assets/img/banner产品icon/营销云.png')" alt="营销云" class="product-icon" />
                <h3 class="product-title">营销云</h3>
              </div>
              <p class="product-desc">数据驱动</p>
            </div>
            <div class="product-features">
              <div class="feature-grid">
                <div class="feature-item" v-for="(feature, index) in marketingCloudFeatures" :key="index">
                  <div class="feature-icon">
                    <img :src="feature.icon" :alt="feature.title" />
                  </div>
                  <div class="feature-content">
                    <h4 class="feature-title">{{ feature.title }}</h4>
                    <p class="feature-desc">{{ feature.desc }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-footer">
              <button class="learn-more-btn" @click="learnMore('marketing-cloud')">
                了解更多 >
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- AI驱动增长板块 -->
    <div class="ai-growth-section">
      <div class="ai-growth-container">
        <div class="ai-growth-header">
          <h2 class="ai-growth-title">用 AI 驱动增长</h2>
          <p class="ai-growth-subtitle">无缝打通场景和数据，深度融合Deepseek，让"活数据"驱动业务增长</p>
          
          <!-- Tab选项移到标题下方 -->
          <div class="ai-tabs">
            <div 
              v-for="(tab, index) in aiTabs" 
              :key="index"
              :class="['ai-tab-item', { active: activeAiTab === index }]"
              @click="setActiveAiTab(index)"
            >
              {{ tab.name }}
            </div>
          </div>
        </div>
        
        <div class="ai-growth-content">
          <!-- 左侧内容区域 -->
          <div class="ai-growth-left">
            <div class="ai-content-display">
              <h3 class="ai-content-title">{{ aiTabs[activeAiTab].title }}</h3>
              <p class="ai-content-subtitle">{{ aiTabs[activeAiTab].subtitle }}</p>
              
              <div class="ai-features">
                <div 
                  v-for="(feature, index) in aiTabs[activeAiTab].features" 
                  :key="index"
                  class="ai-feature-item"
                >
                  <div class="feature-dot"></div>
                  <span>{{ feature }}</span>
                </div>
              </div>
              
              <div class="ai-buttons">
                <button class="ai-btn ai-btn-primary" @click="aiPreview">预约演示</button>
                <button class="ai-btn ai-btn-secondary" @click="aiConsult">立即咨询</button>
              </div>
            </div>
          </div>
          
          <!-- 右侧图片区域 -->
          <div class="ai-growth-right">
            <div class="ai-image-display">
              <img 
                :src="aiTabs[activeAiTab].image" 
                :alt="aiTabs[activeAiTab].title + '流程图'" 
                class="ai-flow-image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 行业解决方案板块 -->
    <div class="industry-solutions-section">
      <div class="industry-container">
        <div class="industry-header">
          <h2 class="industry-title">适配 B2B2C 行业的解决方案</h2>
          <p class="industry-subtitle">不止赋能营销，更赋能数字管理，让数据驱动业务增长</p>
        </div>
        
        <div class="industry-slider-wrapper" ref="sliderWrapper">
          <div class="industry-item-container">
            <div 
              class="industry-slider" 
              ref="industrySlider"
            >
              <div 
                v-for="(industry, index) in industryList" 
                :key="index"
                class="industry-card"
              >
              <div class="card-icon" :class="industry.iconClass">
                <img :src="industry.icon" :alt="industry.name + '图标'" />
              </div>
              <h3 class="card-title">{{ industry.name }}</h3>
              <p class="card-description">{{ industry.description }}</p>
              
              <button class="card-button" @click="learnMore(industry.name)">
                <span class="button-text">{{ industry.buttonText }}</span>
                <i class="el-icon-arrow-right button-arrow"></i>
              </button>
              
              <div class="card-logo" v-if="industry.name !== '家装'">
                <img :src="industry.logo" :alt="industry.name + '行业解决方案'" style="margin-left: 0 !important;" />
              </div>
            </div>
          </div>
          </div>
        </div>
        
        <!-- 导航按钮 - 移到卡片下方 -->
        <div class="slider-navigation-bottom">
          <button class="nav-btn nav-prev" @click="slideLeft" :disabled="!canSlideLeft">
            <i class="el-icon-arrow-left"></i>
          </button>
          <button class="nav-btn nav-next" @click="slideRight" :disabled="!canSlideRight">
            <i class="el-icon-arrow-right"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- 服务优势板块 -->
    <div class="service-advantages-section">
      <div class="advantages-container">
        <div class="advantages-header">
          <h2 class="advantages-title">14 年行业沉淀，信心之选</h2>
        </div>
        
        <div class="advantages-cards">
          <div 
            v-for="(advantage, index) in advantagesList" 
            :key="index"
            class="advantage-card"
          >
            <div class="advantage-image">
              <img :src="advantage.image" :alt="advantage.title" />
            </div>
            <h3 class="advantage-title">{{ advantage.title }}</h3>
            <p class="advantage-description">{{ advantage.description }}</p>
            

          </div>
        </div>
      </div>
    </div>

    <!-- 客户认可组件 -->
    <div class="customer-recognition-wrapper">
      <CustomerRecognition />
    </div>

    <!-- 顶级资本投资（独立板块） -->
    <div class="capital-investors-section">
      <div class="capital-investors-container">
        <div class="capital-investors-header">
          <h2 class="capital-investors-title">顶级资本投资</h2>
        </div>
        <div class="capital-investors-logos">
          <div class="logo-item" v-for="logo in capitalLogoList" :key="logo.name">
            <img :src="logo.src" :alt="logo.name" />
          </div>
        </div>
      </div>
    </div>

    <!-- 营销数字化升级板块 -->
    <MarketingUpgrade />
  </div>
</template>

<script>
// import TypeWriter from '@/components/TypeWriter.vue'
import MarketingUpgrade from '@/components/MarketingUpgrade.vue'
import CustomerRecognition from '@/components/CustomerRecognition.vue'

export default {
  name: "HomePage",
  components: {
    // TypeWriter
    MarketingUpgrade,
    CustomerRecognition
  },
  data() {
    return {
      // 首页banner图片数据
      bannerImage: {
        type: 0,
        developer: "聚焦高客单价领域B2c场景，连接企业和客户，构建可持续经营的客户资产",
        title: "高客单领域智能营销系统",
        text: "点击预约",
        cases: require('@/assets/img/首页banner.png'),
        minCases: require('@/assets/img/首页banner-移动端.png'),
        https: 'https://applmkip5ay1116.pc.xiaoe-tech.com/page/2088805?navIndex=0'
      },
      // 提取的高亮文本数组，用于打字机效果
      // highlightTexts: ['全链路', '活数据', '真智能'],
      isPaused: false,
      logoList: [
        { name: '越秀', src: require('@/assets/img/logowall/越秀.png') },
        { name: '建发房产', src: require('@/assets/img/logowall/建发房产.png') },
        { name: '中海', src: require('@/assets/img/logowall/中海.png') },
        { name: '骏丰', src: require('@/assets/img/logowall/骏丰.png') },
        { name: '九学王', src: require('@/assets/img/logowall/九学王.png') },
        { name: '招商', src: require('@/assets/img/logowall/招商.png') },
        { name: '联发', src: require('@/assets/img/logowall/联发.png') },

      ],
      capitalLogoList: [
        { name: '招商局创投', src: require('@/assets/img/logowall/招商局创投.png') },
        { name: '朗玛峰创投', src: require('@/assets/img/logowall/郎玛峰创投.png') },
        { name: '同创伟业', src: require('@/assets/img/logowall/同创伟业.png') },
        { name: '火山石投资', src: require('@/assets/img/logowall/火山石投资.png') },
        { name: '火山石投资', src: require('@/assets/img/logowall/微禾投资.png') },
      ],
                   // 小程序功能特性
      miniProgramFeatures: [
      { 
          title: '线上商城', 
          icon: require('@/assets/img/产品矩阵icon/线上商城.png')
        },
        // { 
        //   title: '线上展厅', 
        //   icon: require('@/assets/img/产品矩阵icon/线上展厅.png')
        // },
        { 
          title: '活动中心', 
          icon: require('@/assets/img/产品矩阵icon/活动中心.png')
        },
        { 
          title: '优惠券', 
          icon: require('@/assets/img/产品矩阵icon/优惠券.png')
        },
        { 
          title: '社群搭子', 
          icon: require('@/assets/img/产品矩阵icon/社群搭子.png')
        },

        { 
          title: '线上预约', 
          icon: require('@/assets/img/产品矩阵icon/线上预约.png')
        },
        { 
          title: '视频看房', 
          icon: require('@/assets/img/产品矩阵icon/视频看房.png')
        },
        { 
          title: '会员积分', 
          icon: require('@/assets/img/产品矩阵icon/会员积分.png')
        },
        { 
          title: '注册合伙人', 
          icon: require('@/assets/img/产品矩阵icon/客户管理.png')
        },
        { 
          title: '佣金提取', 
          icon: require('@/assets/img/产品矩阵icon/佣金提取.png')
        }
      ],
      
      // 销冠CRM功能特性
      crmFeatures: [
      { 
          title: '电子名片', 
          icon: require('@/assets/img/产品矩阵icon/拓客利器.png')
        },
        { 
          title: '电子物料', 
          icon: require('@/assets/img/产品矩阵icon/购房资料.png')
        },
        { 
          title: '发抖音', 
          icon: require('@/assets/img/产品矩阵icon/抖音直播.png')
        },
        { 
          title: '营销活动', 
          icon: require('@/assets/img/产品矩阵icon/活动中心.png')
        },
        { 
          title: '招募经纪人', 
          icon: require('@/assets/img/产品矩阵icon/招募经纪人.png')
        },
        { 
          title: '排行榜', 
          icon: require('@/assets/img/产品矩阵icon/排行榜.png')
        },
        { 
          title: 'AI 数字人', 
          icon: require('@/assets/img/产品矩阵icon/AI应用.png')
        },
        { 
          title: 'AI 内容创作', 
          icon: require('@/assets/img/产品矩阵icon/AI 内容创作.png')
        },
        { 
          title: 'Aidee', 
          icon: require('@/assets/img/产品矩阵icon/aidee.png')
        },
      ],
      
      // 营销云功能特性
      marketingCloudFeatures: [
        { 
          title: '投放中心', 
          icon: require('@/assets/img/产品矩阵icon/线上展厅.png')
        },
        { 
          title: '渠道中心', 
          icon: require('@/assets/img/产品矩阵icon/渠道中心.png')
        },

        { 
          title: '管理报表', 
          icon: require('@/assets/img/产品矩阵icon/增长获客.png')
        },
        { 
          title: '客户台账', 
          icon: require('@/assets/img/产品矩阵icon/客户管理.png')
        },
        { 
          title: '营销画布', 
          icon: require('@/assets/img/产品矩阵icon/案场管理.png')
        },
        { 
          title: '渠道管理', 
          icon: require('@/assets/img/产品矩阵icon/案场管理.png')
        },
        { 
          title: '内容中心', 
          icon: require('@/assets/img/产品矩阵icon/内容中心.png')
        },
        { 
          title: '交易管理', 
          icon: require('@/assets/img/产品矩阵icon/交易管理.png')
        },

        { 
          title: 'AI 周报', 
          icon: require('@/assets/img/产品矩阵icon/数据洞察.png')
        }
      ],
      // AI驱动增长Tab数据
      activeAiTab: 0,
      aiTabs: [
      {
          name: '活数据',
          title: '活数据体系',
          subtitle: '以动态数据贯通业务全链路，激活增长新势能',
          features: [
            '多源数据融合：打通小程序、智能工牌等触点，整合行为、沟通、业务数据，构建实时更新的“活数据”池',
            '数据价值循环：依托新技术与AI算法，驱动数据在“采集-分析-应用”中持续流转，优化业务策略',
            '智能场景落地：赋能Aidee助手矩阵（AI导购、AI工牌等 ），将数据价值转化为精准服务与高效运营，注入增长动能'
          ],
          image: require('@/assets/img/ai-活数据.png')
        },
        {
          name: '客户洞察',
          title: '智能客户洞察',
          subtitle: '基于AI的深度客户分析和行为洞察',
          features: [
            '多维度客户画像构建，精准识别客户特征',
            '实时行为分析，洞察客户需求和偏好',
            '智能客户分群，实现精准营销策略'
          ],
          image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/crm-four.png'
        },
        {
          name: '销售智能',
          title: '销售智能助手',
          subtitle: 'AI驱动的销售流程优化',
          features: [
            '智能客户意向分析和预测',
            '自动化销售跟进提醒',
            '个性化销售话术推荐'
          ],
          image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/crm-six.png'
        },
        {
          name: '分析智能',
          title: '数据分析智能',
          subtitle: '深度数据洞察和分析',
          features: [
            '实时业务数据分析和可视化',
            '智能异常检测和预警',
            '自动化报表生成和分享'
          ],
          image: 'https://cdn.ideamake.cn/sw-pc/images/web3.0/v2/crm-eleven.png'
        },
        {
          name: 'Aidee',
          title: 'AI助手Aidee',
          subtitle: '您的专属AI业务助手',
          features: [
            '自然语言交互，智能回答业务问题',
            '一键生成业务报告和分析',
            '个性化业务建议和优化方案'
          ],
          image: require('@/assets/img/产品功能图片/客户分析 Agent.png')
        }
      ],
      industryList: [
        {
          name: '房地产',
          description: '专业的房地产行业营销解决方案，帮助开发商和中介机构提升获客效率，优化销售流程，提高转化率',
          iconClass: 'icon-realestate',
          icon: require('@/assets/img/产品方案icon/房地产.svg'),
          // features: ['销冠CRM', '智慧案场', '营销云', '数字沙盘'],
          buttonText: '了解更多',
          logo: require('@/assets/img/行业解决方案企业logo/招商-房地产行业解决方案.png')
        },
        {
          name: '教育',
          description: '为教育行业提供专业的数字化营销解决方案，提升招生效率、优化教学服务',
          iconClass: 'icon-education',
          icon: require('@/assets/img/产品方案icon/教育.svg'),
          // features: ['会员营销系统'],
          buttonText: '了解更多',
          logo: require('@/assets/img/行业解决方案企业logo/九学王-教育行业解决方案.png')
        },
        {
          name: '大健康',
          description: '为大健康行业提供全方位的数字化营销解决方案，提升门店业绩、赋能销售',
          iconClass: 'icon-health',
          icon: require('@/assets/img/产品方案icon/大健康.svg'),
          // features: ['会员营销系统'],
          buttonText: '了解更多',
          logo: require('@/assets/img/行业解决方案企业logo/骏丰-大健康行业解决方案.png')
        },
        {
          name: '汽车',
          description: '为汽车行业销售和服务的数字化转型方案，扩宽获客、提升线索转化成交、优化客户体验，增强品牌竞争力',
          iconClass: 'icon-car',
          icon: require('@/assets/img/产品方案icon/汽车.svg'),
          // features: ['会员营销系统'],
          buttonText: '了解更多',
          logo: require('@/assets/img/行业解决方案企业logo/众菱-汽车行业解决方案.png')
        },
        {
          name: '家装',
          description: '专业的家装行业解决方案，从获客-客户管理-成交交易的全链路营销方案，提升客户满意度和门店业绩',
          iconClass: 'icon-home',
          icon: require('@/assets/img/产品方案icon/家装.svg'),
          // features: ['会员营销系统'],
          buttonText: '了解详情',
          logo: require('@/assets/img/行业解决方案企业logo/骏丰-大健康行业解决方案.png')
        }
      ],
      
      // 服务优势数据
      advantagesList: [
        {
          title: '深度行业洞察与实践指导',
          description: '汇聚各行业数字化转型的成功案例和最佳实践，为企业提供可参考的解决方案模板，助力快速实现业务增长和效率提升。',
          image: require('@/assets/img/10 年行业沉淀，信心之选/深度行业洞察与实践指导.png')
        },
        {
          title: '专业服务团队全程护航',
          description: '配备资深项目经理和技术专家，提供从需求分析到上线运营的全流程服务，确保大型项目顺利实施和成功落地。',
          image: require('@/assets/img/10 年行业沉淀，信心之选/专业服务团队全程护航.png')
        },
        {
          title: '持续价值创造与增长',
          description: '建立完善的客户成功体系，通过持续的培训、优化建议和技术支持，帮助客户最大化产品价值，实现业务持续增长。',
          image: require('@/assets/img/10 年行业沉淀，信心之选/持续价值创造与增长.png')
        }
      ],
      
      // 行业滑动控制
      scrollLeft: 0,
      maxScrollLeft: 0,
      canSlideLeft: false,
      canSlideRight: true
    }
  },
  mounted() {
    // 页面加载完成
    window.addEventListener('resize', this.handleResize);
    this.$nextTick(() => {
      this.initSlider();
    });
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
    const slider = this.$refs.sliderWrapper;
    if (slider) {
      slider.removeEventListener('scroll', this.handleScroll);
    }
  },
  

  methods: {
    // 跳转预约演示
    goReservation(type) {
      this.$router.push({ path: '/reservation', params: { type } })
      // 调用百度统计的代码
      if (type === 0) {
        window._hmt.push(['_trackEvent', 'button','click', '首页banner立即领取按钮']);
      }
    },
    pauseAnimation() {
      this.isPaused = true;
    },
    resumeAnimation() {
      this.isPaused = false;
    },
         setActiveTab(index) {
       this.activeTab = index;
     },
     goSolutionDetail(index) {
       const routes = [
        //  '/solution/member-marketing',
         '/solution/omnichannel-acquisition', 
         '/solution/lead-conversion',
         '/solution/marketing-automation',
         '/solution/private-domain-growth'
       ];
       this.$router.push(routes[index]);
     },
     setActiveAiTab(index) {
       this.activeAiTab = index;
     },
     aiPreview() {
       // 预约演示 - 跳转到预约页面
       this.$router.push('/reservation');
     },
     aiConsult() {
       // 立即咨询
       console.log('立即咨询');
     },
     learnMore(type) {
       // 根据产品类型跳转到对应页面
       if (typeof type === 'string') {
         // 处理产品矩阵的跳转
         if (type === 'miniprogram') {
           // 小程序跳转到社区小程序方案页面
           this.$router.push('/solution/community-miniprogram');
           return;
         }
         
         const productRouteMap = {
           'crm': '/solution/crm',
           'marketing': '/solution/precise-customer',
           'marketing-cloud': '/solution/marketing-cloud'
         };
         
         const route = productRouteMap[type];
         if (route) {
           this.$router.push(route);
           return;
         }
         
         // 处理行业名称跳转
         const industryRouteMap = {
           '房地产': '/industry/real-estate',
           '汽车': '/industry/automotive', 
           '大健康': '/industry/healthcare',
           '教育': '/industry/education',
           '家装': '/industry/home-decoration'
         };
         
         const industryRoute = industryRouteMap[type];
         if (industryRoute) {
           this.$router.push(industryRoute);
         } else {
           console.log(`未找到 ${type} 对应的路由`);
         }
       } else {
         console.log(`参数类型错误: ${typeof type}`);
       }
     },

     
     // 行业滑动控制方法
     initSlider() {
       const slider = this.$refs.sliderWrapper;
       if (slider) {
         // 添加滚动事件监听
         slider.addEventListener('scroll', this.handleScroll, { passive: true });
         this.updateScrollButtons();
       }
     },
     
     handleScroll() {
       this.updateScrollButtons();
     },
     
     updateScrollButtons() {
       const slider = this.$refs.sliderWrapper;
       if (slider) {
         this.scrollLeft = slider.scrollLeft;
         this.maxScrollLeft = slider.scrollWidth - slider.clientWidth;
         this.canSlideLeft = this.scrollLeft > 0;
         this.canSlideRight = this.scrollLeft < this.maxScrollLeft;
       }
     },
     
     slideLeft() {
       const slider = this.$refs.sliderWrapper;
       if (slider) {
         const slideAmount = this.getSlideAmount();
         slider.scrollTo({
           left: Math.max(0, slider.scrollLeft - slideAmount),
           behavior: 'smooth'
         });
       }
     },
     
     slideRight() {
       const slider = this.$refs.sliderWrapper;
       if (slider) {
         const slideAmount = this.getSlideAmount();
         slider.scrollTo({
           left: Math.min(this.maxScrollLeft, slider.scrollLeft + slideAmount),
           behavior: 'smooth'
         });
       }
     },
     
     getSlideAmount() {
       // 根据屏幕尺寸返回滑动距离
       if (window.innerWidth <= 480) return 280; // 240 + 40
       if (window.innerWidth <= 768) return 300; // 260 + 40
       return 390; // 360 + 30
     },
     
     handleResize() {
       // 窗口大小变化时重新计算
       this.$nextTick(() => {
         this.updateScrollButtons();
       });
     }
  }
}
</script>



<style lang="scss" scoped>
.homepage {
  min-height: 100vh;
  overflow-x: visible;
  
  // 确保MarketingUpgrade组件与其他元素无间隙
  :deep(.marketing-upgrade) {
    margin: 0;
    padding: 0;
  }
  
  // 客户认可板块外层包裹添加背景
  .customer-recognition-wrapper {
    background: linear-gradient(135deg, #f0f7ff 0%, #e6f3ff 100%);
  }
  
  // 移动端优化
  @media screen and (max-width: 768px) {
    // 防止水平滚动
    overflow-x: hidden;
    
    // 优化触摸体验
    -webkit-tap-highlight-color: transparent;
    
    // 确保内容不会被状态栏遮挡
    padding-top: 0;
  }
}

.home-banner {
  position: relative;
  height: 600px;
  background: #E6F3FF;
  
  .banner-image {
    height: 600px;
    background: transparent;
    position: relative;
    
    .image {
      width: 100%;
      height: 600px;
      position: absolute;
      left: 0;
      top: 0;
      object-fit: contain;
      object-position: center;
    }
  }
  
  .fixed-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    z-index: 10;
    pointer-events: none;
    
    .carousel {
      width: 1200px;
      margin: 0 auto;
      margin-top: 40px;
      text-align: left;
      pointer-events: auto;
      
      .title {
        font-size: 48px;
        font-weight: 500;
        color: #2D2E30;
        line-height: 60px;
        margin-bottom: 16px;

        .title-line {
          height: 60px;
          display: flex;
          align-items: center;
          
          &:first-child {
            margin-bottom: 8px;
          }
        }
      }
      
      .text {
        font-size: 20px;
        color: #5a5c60;
        line-height: 28px;
        margin-bottom: 48px;
      }
      
      .tags {
        display: flex;
        gap: 32px;
        margin-bottom: 32px;
        
        .tag-item {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #2D2E30;
          
          .tag-icon {
            width: 28px;
            height: 28px;
            object-fit: contain;
          }
          
          span {
            font-size: 20px;
            font-weight: 600;
          }
        }
      }
      
      .first-word-big-button {
        display: inline-block;
        background: #3777F6;
        color: white;
        width: 132px;
        height: 48px;
        line-height: 48px;
        text-align: center;
        border-radius: 0;
        font-size: 16px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s;
        border: none;
        margin-top: 24px;
        
        &:hover {
          background: #2563eb;
        }
      }
    }
  }
}

.home-banner-mobile {
  display: none;
}

// Logo墙样式
.logo-wall {
  padding-bottom: 20px;
  background: #E6F3FF;
  overflow: hidden;
  
  .logo-wall-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
  }
  
  .logo-wall-title {
    text-align: left;
    font-size: 18px;
    font-weight: 400;
    color: #999999;
    margin-bottom: 20px;
    
    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 400;
    }

    .logo-tabs {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: #00000015;
      padding: 4px;
      border-radius: 999px;
      // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    }

    .logo-tab {
      cursor: pointer;
      color: #2D2E30;
      font-size: 16px;
      user-select: none;
      padding: 8px 16px;
      border-radius: 999px;
      background: transparent;
      transition: all 0.2s ease;
      line-height: 1;
    }

    .logo-tab.active {
      background: #3777F6;
      color: #ffffff;
      font-weight: 500;
    }
  }
  
  .logo-scroll-wrapper {
    overflow: hidden;
    width: 100%;
    position: relative;
    
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100px;
      z-index: 2;
      pointer-events: none;
    }
    
    &::before {
      left: 0;
      background: linear-gradient(to right, #E6F3FF, transparent);
    }
    
    &::after {
      right: 0;
      background: linear-gradient(to left, #E6F3FF, transparent);
    }
  }
  
  .logo-scroll-content {
    display: flex;
    animation: scroll 60s linear infinite;
    white-space: nowrap;
    
    &.paused {
      animation-play-state: paused;
    }
    
    .logo-group {
      display: inline-flex;
      flex-shrink: 0;
      
      .logo-item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 240px;
        height: 80px;
        margin: 0 10px;
        flex-shrink: 0;
        
        img {
          width: 200px;
          height: auto;
          object-fit: contain;
        }
      }
    }
  }
  
  @keyframes scroll {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(calc(-240px * 8));
    }
  }

  // 顶级资本静态展示
  .capital-logo-wrapper {
    width: 100%;
  }
  .capital-logos {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    place-items: center;
    row-gap: 16px;
  }
  .capital-logos .logo-item {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
  }
  .capital-logos .logo-item img {
    width: 70%;
    max-width: 200px;
    height: auto;
    object-fit: contain;
  }
}

// 全链路数字营销服务平台板块样式
.marketing-platform-section {
  padding: 80px 0;
  background: #f8f9fa url('https://cdn.ideamake.cn/sw-pc/images/web3.0/cultural-wall-background.png') center/cover no-repeat;
  position: relative;
  overflow: hidden;
  min-height: 600px;
  
  // 背景覆盖层（暂时注释掉以测试背景图）
  .platform-bg-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.3);
    z-index: 1;
    pointer-events: none;
  }
  
  // 背景装饰元素
  .platform-bg-decoration {
    position: absolute;
    border-radius: 100%;
    filter: blur(150px);
    pointer-events: none;
    z-index: 2;
  }
  
  .platform-bg-left {
    left: -10%;
    top: 30%;
    transform: translate(-50%, -50%);
    width: clamp(200px, 35vw, 480px);
    aspect-ratio: 1;
    background: rgba(47, 186, 255, 0.3);
  }
  
  .platform-bg-right {
    right: -10%;
    top: 70%;
    transform: translate(50%, -50%);
    width: clamp(150px, 25vw, 350px);
    aspect-ratio: 1;
    background: rgba(137, 255, 237, 0.2);
  }
  
  .platform-bg-bottom {
    right: 0px;
    bottom: 45px;
    transform: translate(80%, 0%);
    width: clamp(100px, 47vw, 660px);
    aspect-ratio: 33 / 31;
    filter: blur(200px);
    background: rgba(173, 255, 245, 0.4);
  }
  
  .platform-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
    text-align: center;
    position: relative;
    z-index: 3;
  }
  
  .platform-header {
    margin-bottom: 60px;
    text-align: center;
    
    .platform-title {
      font-size: 32px;
      font-weight: 600;
      color: #2d2e30;
      line-height: 1.3;
      margin: 0 0 16px 0;
    }
    
    .platform-subtitle {
      font-size: 16px;
      color: #666666;
      line-height: 1.5;
      white-space: normal;
      margin: 0 auto;
      word-wrap: break-word;
      overflow-wrap: break-word;
    }
  }
  
  .platform-content {
    display: flex;
    justify-content: center;
    align-items: center;
    
    .platform-image {
      max-width: 100%;
      display: flex;
      justify-content: center;
      
      .el-image {
        width: 1200px;
        height: auto;
        max-width: none;
        border-radius: 0;
        cursor: pointer;
      }
      
      // 保持向后兼容
      img {
        width: 1200px;
        height: auto;
        max-width: none;
        border-radius: 0;
      }
    }
  }
}

// 产品矩阵板块样式
.product-matrix-section {
  background: linear-gradient(135deg, #f0f7ff 0%, #e6f3ff 100%);
  padding: 80px 0;
  
  .product-matrix-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
  }
  
  .product-matrix-header {
    text-align: center;
    margin-bottom: 60px;
    
    .product-matrix-title {
      font-size: 32px;
      font-weight: 600;
      color: #2d2e30;
      margin-bottom: 16px;
    }
    
    .product-matrix-subtitle {
      font-size: 16px;
      color: #666666;
      line-height: 24px;
    }
  }
  
  .product-matrix-content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    
    @media (max-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
    }
    
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  
  .product-card {
    background: white;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    height: fit-content;
    
    &:hover {
      box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    }
    
    .product-header {
      text-align: center;
      margin-bottom: 24px;
      
      .product-title-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 8px;
        
        .product-icon {
          width: 44px;
          height: 44px;
          margin-right: 8px;
          object-fit: contain;
        }
        
        .product-title {
          font-size: 26px;
          font-weight: 600;
          color: #2d2e30;
          margin: 0;
          position: relative;
          display: inline-flex;
          align-items: center;
          
          .app-badge {
            background: linear-gradient(135deg, #3777F6, #5B9AFF);
            color: white;
            font-size: 18px;
            font-weight: 600;
            padding: 6px 6px;
            border-radius: 8px;
            margin-left: 8px;
            line-height: 1;
            transform: scale(0.8);
            transform-origin: left center;
          }
        }
      }
      
      .product-desc {
        font-size: 16px;
        color: #999;
        line-height: 20px;
      }
    }
    
    .product-features {
      margin-bottom: 24px;
      
      .feature-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 16px;
        
        .feature-item {
          text-align: center;
          
          .feature-icon {
            width: 52px;
            height: 52px;
            margin: 0 auto 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          
          .feature-content {
            .feature-title {
              font-size: 14px;
              font-weight: 500;
              color: #2d2e30;
              margin-bottom: 4px;
            }
            
            .feature-desc {
              font-size: 10px;
              color: #999;
              line-height: 14px;
              display: none; // 按图片显示要求隐藏描述文案
            }
          }
        }
      }
    }
    
    .product-footer {
      text-align: center;
      
      .learn-more-btn {
        background: transparent;
        color: #3777F6;
        border: 1px solid #3777F6;
        padding: 8px 24px;
        border-radius: 20px;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s ease;
        
        &:hover {
          background: #3777F6;
          color: white;
        }
      }
    }
  }
}

/* AI驱动增长板块 */
.ai-growth-section {
  padding: 80px 0;
  background: #fff;
}

.ai-growth-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.ai-growth-header {
  text-align: center;
  margin-bottom: 60px;
}

.ai-growth-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.ai-growth-subtitle {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 32px;
}

.ai-growth-content {
  display: flex;
  gap: 60px;
  align-items: center;
}

.ai-growth-left {
  flex: 1;
  max-width: 500px;
}

.ai-tabs {
  display: flex;
  background: transparent;
  border-radius: 0;
  padding: 0;
  margin: 0 auto;
  box-shadow: none;
  max-width: 600px;
  justify-content: center;
  gap: 40px;
}

.ai-tab-item {
  flex: none;
  padding: 12px 24px;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  color: #999;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: transparent;
  border: none;
}

.ai-tab-item.active {
  background: #3777F6;
  color: #fff;
  border-radius: 50px;
  box-shadow: 0 2px 8px rgba(55, 119, 246, 0.2);
  transform: scale(1.02);
}

.ai-content-display {
  background: transparent;
  border-radius: 0;
  padding: 32px 0;
  box-shadow: none;
}

.ai-content-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.ai-content-subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 24px;
}

.ai-features {
  margin-bottom: 32px;
}

.ai-feature-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}

.feature-dot {
  width: 6px;
  height: 6px;
  background: #3777F6;
  border-radius: 50%;
  margin-right: 12px;
  flex-shrink: 0;
  margin-top: 8px;
  align-self: flex-start;
}

.ai-feature-item span {
  flex: 1;
  width: 100%;
  word-wrap: break-word;
  overflow-wrap: break-word;
  max-width: calc(100% - 18px); /* 确保文本不会超出容器，减去dot的宽度和间距 */
}

.ai-buttons {
  display: flex;
  gap: 16px;
  flex-direction: row; /* 确保按钮水平排列 */
}

.ai-btn {
  padding: 12px 24px;
  border-radius: 0;
  border: none;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 120px; /* 设置固定宽度，确保所有按钮长度一致 */
  text-align: center;
  white-space: nowrap;
}

.ai-btn-primary {
  background: #3777F6;
  color: #fff;
}

.ai-btn-primary:hover {
  background: #2563eb;
}

.ai-btn-secondary {
  background: transparent;
  color: #3777F6;
  border: 1px solid #3777F6;
}

.ai-btn-secondary:hover {
  background: #3777F6;
  color: #fff;
}

.ai-growth-right {
  flex: 1;
  max-width: 750px;
}

.ai-image-display {
  background: transparent;
  border-radius: 0;
  padding: 24px 0;
  box-shadow: none;
  text-align: center;
}

.ai-flow-image {
  width: 722px !important;
  height: auto !important;
  max-width: none !important;
  border-radius: 8px;
  object-fit: contain;
}

/* 行业解决方案板块 */
.industry-solutions-section {
  --responsive-content-width: 87.5%;
  --responsive-content-max-width: 1200px;
  --responsive-content-clamped-width: min(var(--responsive-content-max-width), var(--responsive-content-width));
  --responsive-gutter-width: calc(50% - var(--responsive-content-clamped-width) / 2);
  
  padding: 80px 0 100px 0;
  background: linear-gradient(135deg, #f0f7ff 0%, #e6f3ff 100%);
  position: relative;
  margin-top: 0;
}

.industry-container {
  position: relative;
  width: 100%;
}

.industry-header {
  max-width: var(--responsive-content-max-width);
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
  margin-bottom: 60px;
}

.industry-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

.industry-subtitle {
  font-size: 16px;
  color: #666;
  line-height: 1.6;
}

.industry-slider-wrapper {
  position: relative;
  overflow-x: scroll;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
  scroll-padding: var(--responsive-gutter-width);
  padding: 10px 0 30px;
  margin: -10px 0 -30px;
  -webkit-overflow-scrolling: touch; // 提升iOS滚动体验
}

.industry-slider-wrapper::-webkit-scrollbar {
  display: none;
}

.industry-item-container {
  width: var(--responsive-content-clamped-width);
  min-width: fit-content;
  padding: 0 var(--responsive-gutter-width);
}

.industry-slider {
  display: flex;
  gap: 30px;
  width: 100%;
  min-width: fit-content;
}

.industry-card {
  background: #fff;
  border-radius: 12px;
  padding: 32px 24px 20px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  text-align: left;
  transition: all 0.3s ease;
  border: 1px solid #f0f0f0;
  display: flex;
  flex-direction: column;
  height: 360px;
  width: 360px;
  flex-shrink: 0;
  scroll-snap-align: start;
  touch-action: pan-y; // 允许垂直滚动，防止水平滚动冲突
}

.industry-card:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
}

.slider-navigation-bottom {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 30px;
  z-index: 10;
  max-width: var(--responsive-content-max-width);
  margin-left: auto;
  margin-right: auto;
  padding: 0 20px;
}

.nav-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #e0e0e0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  transition: all 0.3s ease;
  min-width: 44px; // 确保触摸区域足够大
  min-height: 44px;
  -webkit-tap-highlight-color: transparent;
}

.nav-btn:hover:not(:disabled) {
  background: #f7f7f7;
  color: #333;
  border-color: #e3e3e3;
  transform: scale(1.1);
}

.nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.card-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.card-icon img {
  width: 32px;
  height: 32px;
  object-fit: contain;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
}

.card-description {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 24px;
  flex-grow: 1;
  min-height: 0;
}

.card-button {
  background: transparent;
  color: #3777F6;
  border: none;
  padding: 12px 0;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}

.card-button:hover {
  color: #2563eb;
}

.card-button:hover .button-arrow {
  transform: translateX(4px);
}

.button-text {
  color: inherit;
  font-weight: inherit;
}

.button-arrow {
  color: #3777F6;
  font-size: 14px;
  transition: all 0.3s ease;
}

.card-logo {
  margin-top: 16px;
  text-align: left;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-shrink: 0;
}

.card-logo img {
  height: 48px;
  width: 200px;
  object-fit: contain;
  object-position: left center;
  opacity: 0.8;
  transition: opacity 0.3s ease;
  display: block;
  margin: 0;
  padding: 0;
  filter: grayscale(80%) sepia(20%) hue-rotate(200deg) brightness(0.8);
}

.industry-card:hover .card-logo img {
  opacity: 1;
  filter: grayscale(0%) brightness(1);
}

/* 服务优势板块 */
.service-advantages-section {
  padding: 80px 0 80px 0;
  background: #fff;
}

.advantages-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.advantages-header {
  text-align: center;
  margin-bottom: 60px;
}

.advantages-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
}

/* 顶级资本投资（独立板块） */
.capital-investors-section {
  padding: 80px 0 80px 0;
  background: #fff;
}

.capital-investors-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.capital-investors-header {
  text-align: center;
  margin-bottom: 40px;
}

.capital-investors-title {
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.capital-investors-logos {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  place-items: center;
  row-gap: 16px;
  column-gap: 10px;
}

.capital-investors-logos .logo-item {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.capital-investors-logos .logo-item img {
  width: 85%;
  max-width: 240px;
  height: auto;
  object-fit: contain;
}

.advantages-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-top: 50px;
}

.advantage-card {
  background: #fff;
  border-radius: 12px;
  padding: 32px 24px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.advantage-image {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  position: relative;
  overflow: hidden;
}

.advantage-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  border-radius: 8px;
}

.advantage-title {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
  line-height: 1.4;
}

.advantage-description {
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
}

// 响应式设计
@media screen and (max-width: 768px) {
  .marketing-platform-section {
    padding: 60px 16px;
    min-height: auto;
    
    .platform-bg-left {
      left: -20%;
      top: 20%;
      width: clamp(150px, 50vw, 300px);
    }
    
    .platform-bg-right {
      right: -20%;
      top: 80%;
      width: clamp(100px, 35vw, 200px);
    }
    
    .platform-bg-bottom {
      right: -10%;
      bottom: 20px;
      transform: translate(70%, 0%);
      width: clamp(80px, 60vw, 400px);
    }
    
    .platform-header {
      margin-bottom: 40px;
      
      .platform-title {
        font-size: 20px;
        line-height: 1.4;
      }
      
      .platform-subtitle {
        font-size: 14px;
        color: #666666;
        line-height: 1.5;
        white-space: normal;
        word-wrap: break-word;
        overflow-wrap: break-word;
        margin: 0 auto;
        max-width: 100%;
      }
    }
    
    .platform-content {
      .platform-image {
        .el-image {
          width: 100%;
          max-width: 100%;
          border-radius: 0;
        }
        
        img {
          border-radius: 0;
          width: 100%;
          max-width: 100%;
        }
      }
    }
  }
  
  .ai-growth-content {
    flex-direction: column;
    gap: 40px;
  }
  
  .ai-growth-left {
    max-width: 100%;
  }
  
  .ai-growth-right {
    max-width: 100%;
  }
  
  .ai-tabs {
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .ai-tab-item {
    flex: 1;
    min-width: calc(50% - 4px);
  }
  
  .ai-flow-image {
    border-radius: 6px;
    width: 100% !important;
    height: auto !important;
    max-width: 100% !important;
  }
  
  .ai-buttons {
    flex-direction: column;
  }
  
  .industry-solutions-section {
    --responsive-content-width: 90%;
    --responsive-content-max-width: 600px;
    --responsive-content-clamped-width: min(var(--responsive-content-max-width), var(--responsive-content-width));
    --responsive-gutter-width: calc(50% - var(--responsive-content-clamped-width) / 2);
    
    padding: 60px 0 80px 0;
  }
  
  .industry-header {
    padding: 0 16px;
  }
  
  .slider-navigation-bottom {
    padding: 0 16px;
  }
  
  .industry-slider {
    gap: 20px;
  }
  
  .industry-card {
    padding: 24px 20px;
    width: 260px;
    min-height: 320px;
    height: auto;
    scroll-snap-align: start;
    display: flex;
    flex-direction: column;
    
    .card-description {
      flex-grow: 1;
      min-height: 0;
      overflow: hidden;
    }
    
    .card-button {
      flex-shrink: 0;
    }
  }
  
  .industry-title {
    font-size: 20px;
  }
  
  .industry-subtitle {
    font-size: 14px;
  }
  
  .slider-navigation-bottom {
    margin-top: 20px;
    gap: 12px;
  }
  
  .nav-btn {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
  
  .card-logo {
    margin-top: 12px;
    padding-top: 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-shrink: 0;
  }
  
  .card-logo img {
    height: 40px;
    width: 160px;
    object-position: left center;
    display: block;
  }
  
  .advantages-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .advantage-card {
    padding: 24px 20px;
  }
  
  .advantages-title {
    font-size: 20px;
  }
  
  .advantage-image {
    width: 100%;
    height: 100px;
  }
}

@media screen and (max-width: 480px) {
  .industry-solutions-section {
    --responsive-content-width: 95%;
    --responsive-content-max-width: 400px;
    --responsive-content-clamped-width: min(var(--responsive-content-max-width), var(--responsive-content-width));
    --responsive-gutter-width: calc(50% - var(--responsive-content-clamped-width) / 2);
  }
  
  .industry-header {
    padding: 0 12px;
    
    .industry-title {
      font-size: 20px;
    }
    
    .industry-subtitle {
      font-size: 14px;
    }
  }
  
  .slider-navigation-bottom {
    padding: 0 12px;
  }
  
  .industry-card {
    width: 240px;
    padding: 20px 16px;
    min-height: 300px;
    height: auto;
    scroll-snap-align: start;
    display: flex;
    flex-direction: column;
    
    .card-description {
      flex-grow: 1;
      min-height: 0;
      overflow: hidden;
    }
    
    .card-button {
      flex-shrink: 0;
    }
  }
  
  .slider-navigation-bottom {
    margin-top: 15px;
    gap: 10px;
  }
  
  .card-logo {
    margin-top: 10px;
    padding-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-shrink: 0;
  }
  
  .card-logo img {
    height: 32px;
    width: 120px;
    object-position: left center;
    display: block;
  }
}

// 移动端样式
@media screen and (max-width: 980px) {
  .home-banner {
    display: none;
  }
  
  .home-banner-mobile {
    display: block;
    margin-top: 24px;
    position: relative;
    height: auto;
    background: #E6F3FF;
    width: 100%;
    overflow: hidden;
    
    .banner-image {
      height: auto;
      width: 100%;
      text-align: center;
      background: transparent;
      position: relative;
      
      .image {
        width: 100vw !important;
        height: auto !important;
        position: relative;
        left: 50% !important;
        top: 24px;
        transform: translateX(-50%) !important;
        object-fit: contain;
        object-position: center;
        max-width: none !important;
      }
    }
    
    .fixed-content-mobile {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      pointer-events: none;
      
      .carousel {
        width: 100%;
        padding: 0 20px;
        margin-top: -160px;
        text-align: center;
        pointer-events: auto;
        
        .title {
          font-size: 24px;
          font-weight: 500;
          color: #2D2E30;
          line-height: 28px;
          margin-bottom: 6px;
        }
        
        .text {
          font-size: 16px;
          color: #2D2E30;
          line-height: 24px;
          margin-bottom: 36px;
        }
        
        .tags {
          display: flex;
          justify-content: center;
          gap: 24px;
          margin-bottom: 20px;
          
          .tag-item {
            display: flex;
            align-items: center;
            gap: 6px;
            color: #2D2E30;
            
            .tag-icon {
              width: 28px;
              height: 28px;
              object-fit: contain;
            }
            
            span {
              font-size: 20px;
              font-weight: 600;
            }
          }
        }
        
        .first-word-big-button {
          display: inline-block;
          background: #3777F6;
          color: white;
          width: 132px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          border-radius: 0;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
          margin-top: 16px;
          min-height: 44px; // 确保触摸区域足够大
          
          &:hover {
            background: #2563eb;
          }
          
          // 移动端触摸优化
          @media screen and (max-width: 768px) {
            min-height: 44px;
            -webkit-tap-highlight-color: transparent;
          }
        }
      }
    }
  }
  
  // 移动端Logo墙样式
  .logo-wall {
    padding: 0;
    
    .logo-wall-title {
      font-size: 16px;
      margin-bottom: 20px;
      text-align: left;
      
      h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
      }

      .logo-tabs {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: #00000015;
        padding: 4px;
        border-radius: 999px;
        // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
      }
      .logo-tab {
        font-size: 14px;
        color: #2D2E30;
        padding: 8px 14px;
        border-radius: 999px;
        background: transparent;
      }
      .logo-tab.active {
        background: #3777F6;
        color: #fff;
      }
    }
    
    .logo-scroll-wrapper {
      &::before,
      &::after {
        width: 60px;
      }
      
      &::before {
        background: linear-gradient(to right, #E6F3FF, transparent);
      }
      
      &::after {
        background: linear-gradient(to left, #E6F3FF, transparent);
      }
    }
    
    .logo-scroll-content {
      .logo-group {
        .logo-item {
          width: 140px;
          height: 80px;
          margin: 0 5px;
          
          img {
            width: 120px;
            height: auto;
          }
        }
      }
    }
    
    @keyframes scroll {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(calc(-140px * 8));
      }
    }

    // 资本 logo 静态展示（移动端）
    .capital-logos {
      grid-template-columns: repeat(2, 1fr);
      row-gap: 12px;
    }
    .capital-logos .logo-item {
      height: 60px;
    }
    .capital-logos .logo-item img {
      width: 70%;
      max-width: 140px;
    }
  }
  
  // 移动端产品矩阵板块样式
  .product-matrix-section {
    padding: 40px 0;
    
    .product-matrix-container {
      padding: 0 20px;
    }
    
    .product-matrix-header {
      margin-bottom: 40px;
      
      .product-matrix-title {
        font-size: 20px;
      }
      
      .product-matrix-subtitle {
        font-size: 14px;
      }
    }
    
    .product-matrix-content {
      grid-template-columns: 1fr;
      gap: 20px;
    }
    
    .product-card {
      padding: 20px;
      
      .product-header {
        margin-bottom: 20px;
        
        .product-title-wrapper {
          margin-bottom: 6px;
          
          .product-icon {
            width: 24px;
            height: 24px;
            margin-right: 6px;
          }
          
          .product-title {
            font-size: 22px;
            margin: 0;
          }
        }
        
        .product-desc {
          font-size: 14px;
        }
      }
      
      .product-features {
        margin-bottom: 20px;
        
        .feature-grid {
          gap: 12px;
          
          .feature-item {
            .feature-icon {
              width: 44px;
              height: 44px;
              margin-bottom: 6px;
              
              img {
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
            }
            
            .feature-content .feature-title {
              font-size: 12px;
            }
          }
        }
      }
      
      .product-footer .learn-more-btn {
        padding: 6px 20px;
        font-size: 12px;
      }
    }
  }
  
  // 移动端AI驱动增长板块样式
  .ai-growth-section {
    padding: 40px 0;
    
    .ai-growth-container {
      padding: 0 20px;
    }
    
    .ai-growth-header {
      margin-bottom: 40px;
      
      .ai-growth-title {
        font-size: 20px;
      }
      
      .ai-growth-subtitle {
        font-size: 14px;
      }
    }
    
    .ai-tabs {
      gap: 8px;
      flex-wrap: wrap;
      justify-content: center;
      
      .ai-tab-item {
        padding: 8px 16px;
        font-size: 14px;
        border-radius: 16px;
        min-height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
      }
      
      .ai-tab-item.active {
        background: #3777F6;
        color: #fff;
        border-radius: 16px;
        box-shadow: 0 2px 8px rgba(55, 119, 246, 0.3);
        transform: scale(1.05);
      }
      
      .ai-tab-item:active {
        transform: scale(0.95);
        transition: transform 0.1s ease;
      }
    }
    
    .ai-content-display {
      padding: 20px 0;
      
      .ai-content-title {
        font-size: 16px;
      }
      
      .ai-content-subtitle {
        font-size: 14px;
      }
      
      .ai-features {
        margin-bottom: 24px;
        
        .ai-feature-item {
          font-size: 13px;
          margin-bottom: 12px;
          
          span {
            width: calc(100vw - 40px - 18px); /* 屏幕宽度 - 左右间距(20px*2) - dot宽度(6px) - margin-right(12px) */
            max-width: calc(100% - 18px);
            word-wrap: break-word;
            overflow-wrap: break-word;
            display: block; /* 确保文本独占一行 */
          }
        }
      }
    }
    
    .ai-buttons {
      gap: 16px;
      display: flex;
      flex-direction: row; /* 确保水平排列 */
      justify-content: space-between;
      
      .ai-btn {
        padding: 10px 20px;
        font-size: 13px;
        flex: 1; /* 让按钮平均分配剩余空间 */
        text-align: center;
        white-space: nowrap;
        min-width: 0; /* 允许按钮收缩 */
        width: auto !important; /* 覆盖桌面端的固定宽度 */
      }
    }
  }
  
  // 移动端服务优势板块样式
  .service-advantages-section {
    padding: 40px 0;
    
    .advantages-container {
      padding: 0 20px;
    }
    
    .advantages-header {
      margin-bottom: 40px;
      
      .advantages-title {
        font-size: 20px;
      }
    }
    
    .advantages-cards {
      gap: 20px;
      margin-top: 30px;
    }
    
    .advantage-card {
      padding: 24px 20px;
      
      .advantage-image {
        width: 100px;
        height: 100px;
        margin-bottom: 16px;
      }
      
      .advantage-title {
        font-size: 20px;
        margin-bottom: 10px;
      }
      
      .advantage-description {
        font-size: 13px;
        margin-bottom: 16px;
      }
    }

    // 移动端 顶级资本投资板块样式（<=768px 优化由 980px 规则覆盖）
    // 留空，避免与 980px 规则冲突
  }
  
  // 移动端 顶级资本投资板块样式（<=980px）
  .capital-investors-section {
    padding: 40px 0;
  }
  .capital-investors-container {
    padding: 0 20px;
  }
  .capital-investors-header {
    margin-bottom: 40px;
  }
  .capital-investors-title {
    font-size: 20px !important;
  }
  .capital-investors-logos {
    grid-template-columns: repeat(2, 1fr) !important;
    row-gap: 12px;
    column-gap: 10px;
  }
  .capital-investors-logos .logo-item {
    height: 80px !important;
  }
  .capital-investors-logos .logo-item img {
    width: 75% !important;
    max-width: 180px !important;
  }
}

// 小屏幕设备优化 (480px以下)
@media screen and (max-width: 480px) {
  // 全局移动端优化
  * {
    -webkit-tap-highlight-color: transparent;
  }
  
  // 确保所有可点击元素有足够的触摸区域
  button, .ai-tab-item, .card-button, .learn-more-btn {
    min-height: 44px;
    min-width: 44px;
  }
  
  // 超小屏幕tab优化
  .ai-tabs {
    gap: 4px;
    
    .ai-tab-item {
      padding: 8px 10px;
      font-size: 11px;
      border-radius: 12px;
      min-height: 36px;
    }
  }
  
  // 超小屏幕营销平台板块优化
  .marketing-platform-section {
    padding: 30px 16px;
    
    .platform-header {
      margin-bottom: 30px;
      
      .platform-title {
        font-size: 20px;
        line-height: 1.4;
      }
      
      .platform-subtitle {
        font-size: 14px;
        color: #666666;
        line-height: 1.5;
        white-space: normal;
        word-wrap: break-word;
        overflow-wrap: break-word;
        margin: 0 auto;
        max-width: 100%;
      }
    }
  }
  .home-banner-mobile {
    height: auto;
    margin-top: 24px;
    
    .banner-image {
      height: auto;
      width: 100%;
      
      .image {
        width: 100vw !important;
        height: auto !important;
        position: relative;
        left: 50% !important;
        top: 24px;
        transform: translateX(-50%) !important;
        max-width: none !important;
        object-fit: contain;
      }
    }
    
    .fixed-content-mobile {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      pointer-events: none;
      
      .carousel {
        padding: 0 16px;
        margin-top: -160px;
        
        .title {
          font-size: 20px;
          line-height: 28px;
        }
        
        .text {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 24px;
        }
        
        .tags {
          gap: 16px;
          margin-bottom: 16px;
          
          .tag-item {
            gap: 4px;
            
            .tag-icon {
              width: 24px;
              height: 24px;
            }
            
            span {
              font-size: 16px;
            }
          }
        }
        
        .first-word-big-button {
          width: 120px;
          height: 44px;
          line-height: 44px;
          font-size: 13px;
          margin-top: 12px;
        }
      }
    }
  }
  
  .logo-wall {
    padding: 0;
    
    .logo-scroll-content {
      .logo-group {
        .logo-item {
          width: 120px;
          height: 60px;
          margin: 0 3px;
          
          img {
            width: 100px;
          }
        }
      }
    }
    
    @keyframes scroll {
      0% {
        transform: translateX(0);
      }
      100% {
        transform: translateX(calc(-120px * 8));
      }
    }
  }
  
  .product-matrix-section {
    padding: 30px 0;
    
    .product-matrix-container {
      padding: 0 16px;
    }
    
    .product-matrix-header {
      margin-bottom: 30px;
      
      .product-matrix-title {
        font-size: 20px;
      }
      
      .product-matrix-subtitle {
        font-size: 14px;
      }
    }
    
    .product-card {
      padding: 16px;
      
      .product-header {
        margin-bottom: 16px;
        
        .product-title-wrapper {
          margin-bottom: 4px;
          
          .product-icon {
            width: 20px;
            height: 20px;
            margin-right: 4px;
          }
          
          .product-title {
            font-size: 18px;
          }
        }
        
        .product-desc {
          font-size: 14px;
        }
      }
      
      .product-features {
        margin-bottom: 16px;
        
        .feature-grid {
          gap: 8px;
          
          .feature-item {
            .feature-icon {
              width: 36px;
              height: 36px;
              margin-bottom: 4px;
            }
            
            .feature-content .feature-title {
              font-size: 10px;
            }
          }
        }
      }
      
      .product-footer .learn-more-btn {
        padding: 4px 16px;
        font-size: 11px;
      }
    }
  }
  
  .ai-growth-section {
    padding: 30px 0;
    
    .ai-growth-container {
      padding: 0 16px;
    }
    
    .ai-growth-header {
      margin-bottom: 30px;
      
      .ai-growth-title {
        font-size: 20px;
      }
      
      .ai-growth-subtitle {
        font-size: 14px;
      }
    }
    
    .ai-tabs {
      gap: 6px;
      flex-wrap: wrap;
      justify-content: center;
      
      .ai-tab-item {
        padding: 6px 12px;
        font-size: 12px;
        border-radius: 14px;
        min-height: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
      }
      
      .ai-tab-item.active {
        background: #3777F6;
        color: #fff;
        border-radius: 14px;
        box-shadow: 0 2px 6px rgba(55, 119, 246, 0.3);
        transform: scale(1.05);
      }
      
      .ai-tab-item:active {
        transform: scale(0.95);
        transition: transform 0.1s ease;
      }
    }
    
    .ai-content-display {
      padding: 16px 0;
      
      .ai-content-title {
        font-size: 16px;
      }
      
      .ai-content-subtitle {
        font-size: 14px;
      }
      
      .ai-features {
        margin-bottom: 20px;
        
        .ai-feature-item {
          font-size: 11px;
          margin-bottom: 10px;
          
          span {
            width: calc(100vw - 32px - 18px); /* 屏幕宽度 - 左右间距(16px*2) - dot宽度(6px) - margin-right(12px) */
            max-width: calc(100% - 18px);
            word-wrap: break-word;
            overflow-wrap: break-word;
            display: block; /* 确保文本独占一行 */
          }
        }
      }
    }
    
    .ai-buttons {
      gap: 16px;
      display: flex;
      flex-direction: row; /* 确保水平排列 */
      justify-content: space-between;
      
      .ai-btn {
        padding: 8px 16px;
        font-size: 11px;
        flex: 1; /* 让按钮平均分配剩余空间 */
        text-align: center;
        white-space: nowrap;
        min-width: 0; /* 允许按钮收缩 */
        width: auto !important; /* 覆盖桌面端的固定宽度 */
      }
    }
  }
  
  .service-advantages-section {
    padding: 30px 0;
    
    .advantages-container {
      padding: 0 16px;
    }
    
    .advantages-header {
      margin-bottom: 30px;
      
      .advantages-title {
        font-size: 20px;
      }
    }
    
    .advantages-cards {
      gap: 16px;
      margin-top: 20px;
    }
    
    .advantage-card {
      padding: 20px 16px;
      
      .advantage-image {
        width: 80px;
        height: 80px;
        margin-bottom: 12px;
      }
      
      .advantage-title {
        font-size: 18px;
        margin-bottom: 8px;
      }
      
      .advantage-description {
        font-size: 11px;
        margin-bottom: 12px;
      }
    }

    // 超小屏幕 - 顶级资本投资板块
    .capital-investors-section {
      padding: 30px 0;
    }
    .capital-investors-container {
      padding: 0 16px;
    }
    .capital-investors-header {
      margin-bottom: 20px;
    }
    .capital-investors-title {
      font-size: 20px;
    }
    .capital-investors-logos {
      grid-template-columns: repeat(2, 1fr);
      row-gap: 10px;
      column-gap: 6px;
    }
    .capital-investors-logos .logo-item {
      height: 60px;
    }
    .capital-investors-logos .logo-item img {
      width: 70%;
      max-width: 120px;
    }
  }
}

// 横屏模式优化
@media screen and (max-width: 768px) and (orientation: landscape) {
  .home-banner-mobile {
    height: auto;
    margin-top: 24px;
    
    .banner-image {
      height: auto;
      width: 100%;
      
      .image {
        width: 100vw !important;
        height: auto !important;
        position: relative;
        left: 50% !important;
        top: 24px;
        transform: translateX(-50%) !important;
        max-width: none !important;
        object-fit: contain;
      }
    }
    
    .fixed-content-mobile {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
      pointer-events: none;
      
              .carousel {
          margin-top: -160px;
          
          .title {
            font-size: 20px;
            line-height: 28px;
          }
        
        .text {
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 20px;
        }
        
        .tags {
          gap: 12px;
          margin-bottom: 12px;
          
          .tag-item {
            .tag-icon {
              width: 20px;
              height: 20px;
            }
            
            span {
              font-size: 14px;
            }
          }
        }
        
        .first-word-big-button {
          width: 100px;
          height: 36px;
          line-height: 36px;
          font-size: 12px;
          margin-top: 8px;
        }
      }
    }
  }
  
  .product-matrix-section {
    padding: 20px 0;
    
    .product-matrix-header {
      margin-bottom: 20px;
      
      .product-matrix-title {
        font-size: 20px;
      }
      
      .product-matrix-subtitle {
        font-size: 14px;
      }
    }
  }
  
  .ai-growth-section {
    padding: 20px 0;
    
    .ai-growth-header {
      margin-bottom: 20px;
      
      .ai-growth-title {
        font-size: 20px;
      }
      
      .ai-growth-subtitle {
        font-size: 14px;
      }
    }
  }
  
  .service-advantages-section {
    padding: 20px 0;
    
    .advantages-header {
      margin-bottom: 20px;
      
      .advantages-title {
        font-size: 20px;
      }
    }
  }
}

@media screen and (min-width: 1920px) {
  .home-banner {
    .item {
      text-align: center;
      overflow: hidden;
      
      .left {
        .carousel {
          text-align: left;
        }
      }
      
      .image {
        width: 70% !important;
        left: 50% !important;
        transform: translateX(-50%);
        object-fit: contain;
        object-position: center;
      }
    }
  }
}
</style> 